//import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import proxyapi from './ProxyApi';

// Load Stripe instance once
let stripePromise = null;

const getStripe = async () => {
  if (!stripePromise) {
    // Replace with your actual Stripe publishable key
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

export class StripeService {
  async getStripe() {
    return getStripe();
  }

// In stripe.js, make sure createCheckoutSession is properly handling enterprise data:

async createCheckoutSession(planData) {
  try {
    if (!planData.userId || !planData.price || !planData.period) {
      throw new Error('Missing required fields for checkout');
    }
    
    console.log("Creating checkout session with plan data:", planData);
    
    // Create a checkout session on the server
    const response = await proxyapi.post('/api/v1/payments/create-checkout', planData);
    
    console.log("Checkout session response:", response.data);
    
    if (!response.data || !response.data.sessionId) {
      throw new Error('Invalid response from server');
    }
    
    // Get the sessionId from the response
    const { sessionId } = response.data;
    
    // Redirect to the checkout page
    const stripe = await this.getStripe();
    const { error } = await stripe.redirectToCheckout({
      sessionId
    });
    
    if (error) {
      console.error("Stripe redirect error:", error);
      throw error;
    }
    
    return { success: true };
  } catch (error) {
    console.error('Checkout error:', error);
    throw this.translateError(error);
  }
}

  async getStoredPaymentMethod(userId) {
    try {
      const response = await proxyapi.get(`/api/v1/payments/method?userId=${userId}`);
      return response.data.paymentMethod;
    } catch (error) {
      console.error('Error fetching payment method:', error);
      return null;
    }
  }

  async deletePaymentMethod(userId, paymentMethodId) {
    try {
      await proxyapi.delete('/api/v1/payments/method', {
        data: {
          userId,
          paymentMethodId
        }
      });
      return true;
    } catch (error) {
      throw this.translateError(error);
    }
  }

  translateError(error) {
    // Extract error message from axios response
    const errorResponse = error.response?.data;
    
    if (errorResponse?.code === 'card_declined') {
      return new Error('Your card was declined. Please try a different card.');
    }
    if (errorResponse?.code === 'expired_card') {
      return new Error('Your card has expired. Please update your card.');
    }
    if (typeof errorResponse?.message === 'string') {
      return new Error(errorResponse.message);
    }
    if (error instanceof Error) {
      return error;
    }
    return new Error('Payment processing failed. Please try again.');
  }
}

// Create and export singleton instance
export const stripeService = new StripeService();